import Vue from 'vue'
import i18n from '../i18n'

Vue.prototype.$appVersion = process.env.VUE_APP_VERSION

Vue.prototype.$rules = {
  email: v => !!(v || '').match(/@/) || 'Please enter a valid email',
  length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
  lengthLowerThan: len => v => (v || '').length <= len || `Invalid character length, required ${len}`,
  password: v => !!(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
    'Password must contain an upper case letter, a numeric character, and a special character',
  required: v => !!v || i18n.t('required'),
  equal: v2 => v => v == v2 || `مقادیر با هم برابر نیستند`,
};